/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private loaderPromise: Promise<void> | null = null;

  load(): Promise<void> {
    if (this.loaderPromise) {
      return this.loaderPromise;
    }

    this.loaderPromise = new Promise<void>((resolve, reject) => {
      if ((window as any).google && (window as any).google.maps) {
        // Ya cargado
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMaps.apiKey}&libraries=marker&loading=async`;
      script.async = true;
      script.defer = true;

      script.onload = () => resolve();
      script.onerror = err => reject(err);

      document.head.appendChild(script);
    });

    return this.loaderPromise;
  }
}
